
export default function Module (name, type, variable) {
  /*
  - name: the name of the module
  - type: the prototype's type, if any
  - variable: the name of the prototype's associated variable
  */
  this.name = name
  this.type = type || null
  this.variable = variable || null
  this.items = {}
  this.modules = []
  this.prototypes = []
}

window.Module = Module // for debugging

Module.pythonLoaded = false // if python's module have been loaded
Module.scripts = null // custom scripts, to load after python
Module.loaded = false // if custom packages have been loaded

Module.pythonModules = {} // the modules only from python
Module.pythonPrototypes = {} // the prototypes only from python
Module.modules = {} // the modules including custom ones
Module.prototypes = {} // the prototypes including custom ones

function cleanObject (obj) {
  // brython return a {_class_, js: {}} object, clean that
  if (obj instanceof Function) {
    return function () {
      return cleanObject(obj.apply(this, arguments))
    }
  } else if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      obj[i] = cleanObject(obj[i])
    }
  } else if (obj && obj.js) {
    obj = obj.js
    for (let n of Object.keys(obj)) {
      obj[n] = cleanObject(obj[n])
    }
  }
  return obj
}

Module.loadScripts = function (scripts) {
  /* load the custom scripts after the python scripts */
  Module.scripts = scripts
  if (!Module.pythonLoaded) return
  let modules = {}
  let prototypes = {}
  for (let name in Module.pythonModules) {
    modules[name] = Module.pythonModules[name].clone()
  }
  for (let name in Module.pythonPrototypes) {
    prototypes[name] = Module.pythonPrototypes[name].clone()
  }
  for (let script of scripts) {
    if (!(script.module in modules)) {
      modules[script.module] = new Module(script.module)
    }
    modules[script.module].add(script.function, script.docstring)
  }
  Module.modules = modules
  Module.prototypes = prototypes
  Module.loaded = true
}

Module.prototype.clone = function () {
  /* clone a module, in order to extend it */
  let mod = new Module(this.name, this.type, this.variable)
  mod.items = { ...this.items }
  mod.modules = [...this.modules]
  mod.prototypes = [...this.prototypes]
  return mod
}

Module.prototype.init = function (items, docs) {
  /*
  Inits a module from python modules
  - items: a dict of functions and values
  - docs: a list of name-doc tuples [(name, doc), ...]
  */
  for (let f in items) {
    this.items[f] = items[f]
  }
  docs.sort((a, b) => (a[0] > b[0]) - (a[0] < b[0]))
  for (let tuple of docs) {
    this.parseDoc(tuple[0], tuple[1])
  }
}

const FUN_NOT_IMPL = () => {
  throw new Error('Custom script method not available')
}

Module.prototype.add = function (name, doc) {
  this.items[name] = FUN_NOT_IMPL
  this.parseDoc(name, doc)
}

// pattern for a function call arguments
// ex:    array a
//        integer stop=s.length
const FUN_PATTERN = new RegExp('(\\w+) (\\w+)(?:=(' +
  '(?:[^,\\[\\]()]|\\([^)]*\\)|\\[[^\\]]*\\])*' +
  '(?:[^,\\[\\]() ]|\\([^)]*\\)|\\[[^\\]]*\\])' +
  '))?', 'g')
const FUN_SUB = (_, _1, _2, _3) => {
  // 1: type, 2: name, 3: default value
  // make the name bold and the default value monospace
  let out = _1 + ' *' + _2 + '*'
  if (_3) out += '=`' + _3 + '`'
  return out
}
// pattern to remove the first argument
const PROTO_PATTERN = /^\(\w+ \*\w+\*\s*(?:(\[)?,\s*|(\)))/g
const PROTO_SUB = (_, _1, _2) => '(' + (_1 || _2 || '')

Module.prototype.parseDoc = function (name, doc) {
  /* parse the documentation */
  for (doc of doc.replace(/\t/g, '').split('\n\n')) {
    // remove begin and end newlines, and split by newline
    doc = doc.replace(/^\n*/, '').replace(/\n*$/, '').split('\n')
    // first line is the arguments
    let def = doc[0]
    // next lines are text explanations
    doc = doc.slice(1)
    let proto = this.variable, mod = this.name
    // sometimes the first line is "!Module!" or "!Prototype!"
    // to indicate that the function is only available
    // in the module or in the prototype
    if (def[0] === '!') {
      if (def === '!Module!') proto = false
      else if (def === '!Prototype!') mod = false
      // then the next line is the definition
      def = doc[0]
      doc = doc.slice(1)
    }
    doc = doc.join('\n')
    // the definition is a function call
    // ex:    (integer min=0, integer max) integer
    if (def[0] === '(') {
      // parse function arguments
      def = def.replace(FUN_PATTERN, FUN_SUB)
      // add the function in the module
      if (mod) {
        this.modules.push({
          name: name,
          cast: 'function',
          prefix: mod + '.',
          definition: def,
          doc: doc,
        })
        // if both for module and prototype, remove the first argument
        // as it will be pass as "this" in the prototype
        if (proto) def = def.replace(PROTO_PATTERN, PROTO_SUB)
      }
      if (proto) {
        this.prototypes.push({
          name: name,
          cast: 'function',
          prefix: proto + '.',
          definition: def,
          doc: doc,
        })
      }
    // the definition is a constant or a property
    // ex:    integer
    } else {
      if (mod) {
        this.modules.push({
          name: name,
          cast: def,
          prefix: mod + '.',
          definition: ' ' + def, // add a space after the name
          doc: doc,
        })
      }
      if (proto) {
        this.modules.push({
          name: name,
          cast: def,
          prefix: proto + '.',
          definition: ' ' + def, // add a space after the name
          doc: doc,
        })
      }
    }
  }
}

window.LOAD_MODULES((name, type, variable, items, docs) => {
  /* call the function defined in index.htlm to start loading the modules */
  let mod = new Module(name, type, variable)
  mod.init(cleanObject(items), docs)
  Module.pythonModules[name] = mod
  Module.modules[name] = mod
  if (type) {
    Module.pythonPrototypes[type] = mod
    Module.prototypes[type] = mod
  }
  Module.pythonLoaded = true
  if (Module.scripts) {
    Module.loadScripts(Module.scripts)
  }
})
